// Imports
import { withStyles, Dialog, DialogContent } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { messageShow } from "../../common/api/actions";
import PropTypes from "prop-types";
import { remove, createGoals } from "../api/actions/mutation";
import styles from "./styles";
import { listGoals } from "../api/actions/query";
import { Pagination, Typography, Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { checkPermission } from "../../common/Sidebar/checkPermission";
import GoalCard from "./GoalCard";

// Component
class Goals extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      count: 0,
      currentPageActive: 1,
      currentPageExpired: 1,
      goalsPerPage: 10,
      sortDirection: null,
      sortedGoals: props.goals,
      selectedNotificationType: null,
      permissions:{
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      }
    };
  }

  componentDidMount() {
    this.verifyPermissions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.goals !== this.props.goals) {
      this.setState({ sortedGoals: this.props.goals });
    }
  }

  verifyPermissions = async () =>{
      const modulePermissions =await checkPermission("marketing","reward.goals");
      this.setState({permissions:{canView:modulePermissions.canView,canCreate:modulePermissions.canCreate,canEdit:modulePermissions.canEdit,canDelete:modulePermissions.canDelete}});
  }

   handleActivePageChange = (event, pageNumber) => {
    this.setState({ currentPageActive: pageNumber });
  };

  handleExpiredPageChange = (event, pageNumber) => {
    this.setState({ currentPageExpired: pageNumber });
  };

  handleSortByExpiryDate = () => {
    const { sortDirection } = this.state;
    const { goals } = this.props; 
    let newDirection = 'asc';

    if (sortDirection === 'asc') {
      newDirection = 'desc';
    }

    const sortedGoals = [...goals].sort((a, b) => {
      const dateA = new Date(a.expiryDate);
      const dateB = new Date(b.expiryDate);

      return newDirection === 'asc' ? dateA - dateB : dateB - dateA;
    });

    this.setState({
      sortedGoals, 
      sortDirection: newDirection,
      currentPage: 1, 
    });
  };
  
  renderSortArrow = () => {
    const { sortDirection } = this.state;
    if (!sortDirection) return null;

    const arrowStyle = {
      color: '#007BFF'
    };

    return (
      <span style={arrowStyle}>
        {sortDirection === 'asc' ? '▲' : '▼'}
      </span>
    );
  };


  isValidDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize the time portion
    return date >= today; // Check if the date is today or in the future
  };

  handleDateChange = (dateType, date) => {
    if (!this.isValidDate(date)) {
      alert("Please select a current or future date.");
      return;
    }

    this.setState({ [dateType]: date });
  };


  handleClone = async (goal) => {
    const { createGoals, messageShow, goals, refresh } = this.props;

    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    const formattedExpiryDate = expiryDate.toISOString().split('T')[0];

    const clonedGoal = {
      ...goal,
      goalName: `${goal.goalName} (Clone)`,
      startDate: new Date().toISOString().split('T')[0],
      expiryDate: formattedExpiryDate,
    };
    try {
      const { data } = await createGoals(clonedGoal);
      if (data.success) {
        this.setState((prevState) => ({
          goals: [...(goals || []), data.data], 
        }));
        refresh();
        messageShow('Goal cloned successfully!');
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      console.error('Error cloning goal:', error);
      messageShow('Error cloning goal. Please try again.');
    }
  };

  handleSelectGoal = (goalId) => {
    this.props.onSelectGoal(goalId); 
  };

  handleSelectAllGoals = () => {
    this.props.onSelectAllGoals(this.state.goals);
  };
  
  isGoalExpired = (goal) => {
    return goal.isExpired;
  };

  render() {
    const { currentPage, currentPageActive, currentPageExpired, goalsPerPage, sortedGoals,permissions } = this.state;
    const { classes, goals, selectedGoals, popUp, closePopUp, selectedGoalId, notificationPermissions, refresh, history } = this.props;
  
    const activeGoals = sortedGoals.filter(goal => !this.isGoalExpired(goal));
    const expiredGoals = sortedGoals.filter(goal => this.isGoalExpired(goal));

    const indexOfLastActive = currentPageActive * goalsPerPage;
    const indexOfFirstActive = indexOfLastActive - goalsPerPage;
    const paginatedActiveGoals = activeGoals.slice(indexOfFirstActive, indexOfLastActive);

    const indexOfLastExpired = currentPageExpired * goalsPerPage;
    const indexOfFirstExpired = indexOfLastExpired - goalsPerPage;
    const paginatedExpiredGoals = expiredGoals.slice(indexOfFirstExpired, indexOfLastExpired);
    return (
      <div className={classes.root}>
         {sortedGoals.length === 0 && (
            <Typography variant="h6" sx={{ m: 2, textAlign: 'center' }}>
                No Goals found.
            </Typography>
        )}
        {activeGoals.length > 0 && (
          <>
            <Typography variant="h6" sx={{ m: 2 }}>Active Goals</Typography>
            <Grid container spacing={2}>
              {paginatedActiveGoals.map(goal => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={goal._id}>
                  <GoalCard
                    goal={goal}
                    permissions={permissions}
                    onSelectReward={this.handleSelectGoal}
                    onClone={this.handleClone}
                    onOpenMessagingDialog={this.props.openPopUp}
                    refresh={refresh}
                  />
                </Grid>   
              ))}
            </Grid>
            {activeGoals.length > goalsPerPage && (
             <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
              <Pagination
               count={Math.ceil(activeGoals.length / goalsPerPage)}
               page={currentPageActive}
               onChange={this.handleActivePageChange}
               color="primary"
               siblingCount={1}
               boundaryCount={1}
              />
             </div>
            )}
          </>
        )}
        {expiredGoals.length > 0 && (
          <>
            <Typography variant="h6" sx={{ m: 2, mt: 4 }}>Expired Goals</Typography>
            <Grid container spacing={2}>
              {paginatedExpiredGoals.map(goal => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={goal._id}>
                  <GoalCard
                    goal={goal}
                    permissions={permissions}
                    onSelectReward={this.handleSelectGoal}
                    onClone={this.handleClone}
                    onOpenMessagingDialog={this.props.openPopUp}
                    refresh={refresh}
                  />
                </Grid>
              ))}
            </Grid>
            {expiredGoals.length > goalsPerPage && (
              <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                <Pagination
                  count={Math.ceil(expiredGoals.length / goalsPerPage)}
                  page={currentPageExpired}
                  onChange={this.handleExpiredPageChange}
                  color="primary"
                  siblingCount={1}
                  boundaryCount={1}
                />
              </div>
            )}
          </>
        )}
      
        <Dialog open={popUp} onClose={() => { this.setState({ selectedNotificationType: null }); closePopUp(); }} fullWidth>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <Typography variant="h6">Choose Notification Type</Typography>
                <IconButton aria-label="close" onClick={() => { this.setState({ selectedNotificationType: null }); closePopUp(); }} size="small">
                  <CloseIcon />
                </IconButton>
              </div>
              {['Email', 'FB Post', 'Push Notification'].map(type => (
                <button
                  key={type}
                  style={{
                    padding: '10px 12px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                    borderRadius: 4,
                    background: '#f5f5f5'
                  }}
                  onClick={() => {
                    const routeType = type.toLowerCase().replace(/\s+/g, "-");
                    const selectedGoal = sortedGoals.find(goal => goal._id === selectedGoalId);
                    history.push({
                     pathname: `/messaging/${routeType}/create`,
                     state: {
                       rewardData: {
                        ...selectedGoal,
                        type: "goal",
                       },
                     }
                    });
                    this.setState({ selectedNotificationType: null });
                    closePopUp();
                  }}
                >
                  {type}
                </button>
              ))}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
Goals.propTypes = {
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  createGoals: PropTypes.func.isRequired,
  notificationPermissions: PropTypes.object.isRequired,
};
function listState(state) {
  return {
    goalsParent: state.goalsParent,
  };
}

export default connect(listState, {
  listGoals,
  remove,
  messageShow,
  createGoals,
})(withRouter(withStyles(styles)(Goals)));
